import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { contextConnect, useContextSystem } from '@wp-g2/context';
import React from 'react';
import { Text } from '../Text';
import { getInitials } from './Initials.utils';

function Initials(props, forwardedRef) {
  var _useContextSystem = useContextSystem(props, 'Initials'),
      name = _useContextSystem.name,
      otherProps = _objectWithoutProperties(_useContextSystem, ["name"]);

  var initials = getInitials(name);
  return /*#__PURE__*/React.createElement(Text, Object.assign({
    weight: 500
  }, otherProps, {
    ref: forwardedRef
  }), initials);
}

export default contextConnect(Initials, 'Initials');